const setIsMyQuizAnswersLoaded = (state, payload) => {
  state.isMyQuizAnswersLoaded = payload
}

const setMyQuizAnswers = (state, payload) => {
  state.myQuizAnswers = payload
}

export default {
  setIsMyQuizAnswersLoaded,
  setMyQuizAnswers,
}
